import {FormControl, FormField} from 'platform/components';
import {Box, HStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {
  MAX_NUMBER,
  MIN_NUMBER,
  MultipleLocationsFormType,
} from '../types/MultipleLocationsFormSchema';

interface VectorRowProps {
  index: number;
  control: FormControl<MultipleLocationsFormType>;
  formApi: UseFormReturn<MultipleLocationsFormType>;
}

export function VectorRow(props: VectorRowProps) {
  const isSelected = useWatch({
    control: props.control,
    name: `definition.${props.index}.isSelected`,
  });

  return (
    <HStack spacing={4} align="center">
      <Box width={5}>
        <FormField
          type="checkbox"
          name={`definition.${props.index}.isSelected`}
          control={props.control}
          onChange={() => props.formApi.trigger()}
        />
      </Box>
      <Box flex={1}>
        <FormField
          type="choice"
          name={`definition.${props.index}.vectorType`}
          control={props.control}
          options={[
            {
              label: i18n.t('entity.tireWarehouses.labels.aisle'),
              value: 'AISLE',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.rack'),
              value: 'RACK',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.level'),
              value: 'LEVEL',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.position'),
              value: 'POSITION',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.other'),
              value: 'OTHER',
            },
          ]}
          isDisabled
          isNotClearable
        />
      </Box>
      <Box flex={1}>
        <FormField
          type="number"
          name={`definition.${props.index}.number`}
          control={props.control}
          minStepperValue={MIN_NUMBER}
          maxStepperValue={MAX_NUMBER}
          isDisabled={!isSelected}
          isStepperVisible
        />
      </Box>
      <Box flex={1}>
        <FormField
          type="choice"
          name={`definition.${props.index}.symbolType`}
          control={props.control}
          options={[
            {
              label: i18n.t('entity.tireWarehouses.labels.alphabet'),
              value: 'ALPHABET',
            },
            {
              label: i18n.t('general.labels.number'),
              value: 'NUMBERS',
            },
          ]}
          isNotClearable
          onChange={() => props.formApi.trigger()}
          isDisabled={!isSelected}
        />
      </Box>
      <Box flex={1}>
        <FormField
          type="text"
          name={`definition.${props.index}.beginAt`}
          control={props.control}
          isDisabled={!isSelected}
        />
      </Box>
    </HStack>
  );
}
